import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { ValType_TimeRange } from '@app/hcs-shared/core';
import './Editor_TimeValue.scss';
import { ModuleFE_Value } from '../../../../../_entity/value/index.js';
import { Component_TimeRangeValueEditor } from './componentes/index.js';
export class Editor_TimeValue extends ComponentSync {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextState.editableValue.tag !== nextState.editableTag)
            return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editableValue ??= new EditableDBItemV3(nextProps.value, ModuleFE_Value)
            .setOnChanged(async (editable) => this.reDeriveState({ editableValue: editable }));
        state.editableTag = state.editableValue.tag;
        return state;
    }
    renderTimeRanges = (editableTimeRanges) => {
        return _jsx(LL_V_L, { className: 'value-editor__time__time-ranges', children: editableTimeRanges.item.map((item, index) => {
                const editableTimeRange = editableTimeRanges.editProp(index, {});
                return _jsx(Component_TimeRangeValueEditor, { deleteItem: () => editableTimeRanges.removeArrayItem(index), editable: editableTimeRange }, index);
            }) });
    };
    render() {
        //FIXME: Hack, honestly I'm not sure how to work with the data as generic and value with editable item
        const UiTimeDataEditable = this.state.editableValue.editProp('data', {});
        const timeRangesEditable = UiTimeDataEditable.editProp('timeRanges', []);
        return _jsxs(LL_V_L, { className: 'value-editor__time', children: [_jsx("div", { className: 'editor-title', children: "Create/Edit Time Ranges" }), this.renderTimeRanges(timeRangesEditable), _jsx(Button, { variant: 'primary', onClick: () => timeRangesEditable.updateArrayAt(ValType_TimeRange), children: "Add new time Range" })] });
    }
}
//# sourceMappingURL=Editor_TimeValue.js.map